import Axios from 'axios';
import { merge } from 'lodash';
import moment from 'moment';
import React from 'react';
import v4 from 'uuid';
import * as Yup from 'yup';
import userACL from '../../../store/access';
import { URL } from '../../../store/path';
import { displayDateWithTime } from '../../../utilities/listUtils';
import { parseDateFromFormats } from '../../../utilities/parseDate';


export const maruti = () => ({
    id: v4(),
    code: "",
    name: "",
    segid: "",
    cid: "",
    status: 1,
    dt_create: "",
    dt_update: "",
    uid_create: "",
    uid_update: ""
})


export const oldsync = () => ({
    dtValue: ""
})

export const missingUtd = () => ({
    utd: ""
})

export const missingUtdSchema = Yup.object().shape({
    utd: Yup.number().required("UTD is Required!"),
})

Yup.addMethod(Yup.date, 'format', parseDateFromFormats);
export const marutiSchema = Yup.object().shape({

    id: Yup.string()
        .required('This is a Required Field'),

    code: Yup.string()
        .required('This is a Required Field'),

    name: Yup.string()
        .required('This is a Required Field'),

    status: Yup.number().integer().nullable(),
    segid: Yup.string().nullable(),
    cid: Yup.string().nullable(),
    txnid: Yup.string().nullable(),
    dt_create: Yup.string().nullable(),
    dt_update: Yup.string().nullable(),
    user_create: Yup.string().nullable(),
    user_update: Yup.string().nullable()

});

export const oldSyncSchema = Yup.object({
    dtValue: Yup.string()
        .required('Sync Date Required'),
})

function filterDate(rows, id, filterValue) {
    return rows.filter(row => {
        let rowValue = moment(row.values[id]).format("DD-MM-YYYY HH-mm-ss")
        let check = filterValue.replace(/[ ]/gi, " ").replace(/[*]/gi, "-").replace(/[.]/gi, "-").replace(/[+]/gi, "-").replace(/[/]/gi, "-").replace(/[,]/gi, "-").replace(/[:]/gi, "-")
        return rowValue !== undefined ?
            String(rowValue).toLowerCase().startsWith(String(check).toLowerCase())
            : true
    })
}

export const searchColumns = [
    {
        Header: <div style={{ textAlign: 'left' }} >UTD</div>,
        accessor: 'UTD',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'syncfilter9'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >Txn Date</div>,
        accessor: 'TRANS_DATE',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: '8px' }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? displayDateWithTime(row.value) : ""}</div>,
        classNameGet: 'syncfilter1',
        filter: filterDate

    },
    {
        Header: <div style={{ textAlign: 'left' }} >Parent Group</div>,
        accessor: 'PARENT_GROUP',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'syncfilter7'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >Dealer Code</div>,
        accessor: 'MUL_DEALER_CD',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'syncfilter5'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >LOC CD</div>,
        accessor: 'LOC_CD',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'syncfilter8'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >Txn Type</div>,
        accessor: 'TRANS_TYPE',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'syncfilter2'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >Txn ID</div>,
        accessor: 'TRANS_ID',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'syncfilter3',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >Txn Ref Num</div>,
        accessor: 'TRANS_REF_NUM',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'syncfilter4',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >Message</div>,
        accessor: 'msg',
        Cell: row => <div className='msgEllipsisDiv' style={{ width: '85%', paddingLeft: "5px" }} >{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? (row.cell.row.original.type === "in-process" ? "Please wait some time" : row.value) : ""}</div>,
        classNameGet: 'syncfilter6',

    },

]



export function syncUtdNo(value, values) {
    const data = merge({}, userACL.atFetch())
    data.rlbboxid = data.boxId
    delete data.boxId
    return Axios.post(URL + '/maruti-sync-repost/' + value.utd, data)
        .then(response => {
            if (response.data.type === 'error') {
                return response.data.msg
            }
        })
        .catch(error => ({ error }))
}